import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Hook to invalidate the enterprise directories query.
 * Use this after creating or deleting directory sync configurations.
 */
export const useInvalidateDirectories = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["enterprises.directories"]
    });
  }, [queryClient]);
};
